import React, {useEffect, useState} from 'react';
import {Translate} from "../../../lang/lang";
import {useSelector} from "react-redux";
import {selectLang} from "../../../store/reducers/main/main";
import CustomFloatingLabelSelect from "../../floating-custom-select/CustomFloatingLabelSelect";

const WarehouseOperationSelectStatus = ({defaultValue, onChange, placeholder, ...props}) => {
    const [value, setValue] = useState(null);
    const lang = useSelector(selectLang);
    const t = Translate;

    const options = [
        {value: null, label: t(lang, "warehouse.operation.item.common.filter.status.all")},
        {value: true, label: t(lang, "warehouse.operation.item.common.filter.status.confirmed")},
        {value: false, label: t(lang, "warehouse.operation.item.common.filter.status.no_confirmed")}
    ]

    useEffect(() => {
        if (defaultValue !== null) {
            const val = options.find(v => v.value === defaultValue);
            setValue(val);
        } else {
            setValue(options[0]);
        }
    }, [defaultValue])

    const onChangeState = option => {
        setValue(option);
        onChange(option);
    }

    const getOptionValue = option => option.value;
    const getOptionLabel = option => t(lang, option.label);

    return (
        <CustomFloatingLabelSelect
            {...props}
            label={placeholder}
            value={value}
            hideSelectedOptions
            onChange={onChangeState}
            options={options}
            getOptionLabel={getOptionLabel}
            getOptionValue={getOptionValue}
        />
    );
};

export default WarehouseOperationSelectStatus;
